import React from 'react'
import { Link } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import utils from '../../../utils/index'
import { enums, routes } from '../../../constants'

const statusLancamentoFinanceiroTemplate = (rowData) => {
  return enums.StatusLancamento[rowData.statusLancamentoFinanceiro] || rowData.statusLancamentoFinanceiro
}

const oidLancamentoFinanceiroTemplate = (rowData) => {
  if (!rowData.oidLancamentoFinanceiro) {
    return null
  }
  return (
    <Link to={`${routes.PATH_LANCAMENTO_FINANCEIRO}/${rowData.oidLancamentoFinanceiro}`}>
      {rowData.oidLancamentoFinanceiro}
    </Link>
  )
}

export class ReconciliacaoPixAutomaticoList extends React.Component {
  render() {
    const { records, selectedRecords, onSelectionChange, messages, resultado } = this.props

    const erros = resultado && resultado.erros ? resultado.erros : {}
    const linhasErro = Object.keys(erros).map((oidItem) => ({ oidItem, mensagem: erros[oidItem] }))

    return (
      <div>
        <DataTable
          value={records}
          selection={selectedRecords}
          onSelectionChange={onSelectionChange}
          dataKey="oidItem"
          emptyMessage="Nenhum candidato a reconciliação encontrado"
          autoLayout={true}
        >
          <Column selectionMode="multiple" style={{ width: '3em' }} />
          <Column field="idRec" header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.idrec')} sortable />
          <Column field="txid" header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.txid')} sortable />
          <Column
            field="codigoPsp"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.codigopsp')}
            sortable
          />
          <Column
            field="dataRecebimentoWebhook"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.datarecebimentowebhook')}
            body={(rowData) => utils.formatarDataHoraCompleta(rowData.dataRecebimentoWebhook)}
            sortable
          />
          <Column
            field="statusPspAtual"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.statuspspatual')}
            sortable
          />
          <Column
            field="statusPspRecalculado"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.statuspsprecalculado')}
            sortable
          />
          <Column
            field="statusCobranca"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.statuscobranca')}
            sortable
          />
          <Column
            field="oidLancamentoFinanceiro"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.oidlancamentofinanceiro')}
            body={oidLancamentoFinanceiroTemplate}
            sortable
          />
          <Column
            field="statusLancamentoFinanceiro"
            header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.statuslancamentofinanceiro')}
            body={statusLancamentoFinanceiroTemplate}
            sortable
          />
        </DataTable>

        {resultado && (
          <div style={{ marginTop: '1.5em' }}>
            <label className="label">{utils.getMessage(messages, 'reconciliacaopixautomatico.label.resultado')}</label>
            <p>
              {resultado.sucesso.length} item(ns) reconciliado(s) com sucesso, {linhasErro.length} erro(s)
            </p>
            {linhasErro.length > 0 && (
              <DataTable value={linhasErro} autoLayout={true}>
                <Column field="oidItem" header="Oid Item" />
                <Column field="mensagem" header={utils.getMessage(messages, 'reconciliacaopixautomatico.label.mensagemerro')} />
              </DataTable>
            )}
          </div>
        )}
      </div>
    )
  }
}
